<template>
  <div class="cn-igs" role="group" aria-label="...">
    <span class="cn-igs__title">Implementation Groups</span>
    <button
      class="button ig1"
      :class="[ig === 1 ? 'active' : '']"
      @click="setIgTo(1, $event)"
      type="button"
    >
      <span>
        IG1
        <a
          class="tooltip"
          v-if="datasource && datasource.tooltipIG1"
          :tooltipHeader="`<span class='tooltip-header'>IG1 - </span>${datasource.tooltipIG1.value}`"
        ></a>
      </span>
    </button>
    <button
      class="button ig2"
      :class="[ig === 2 ? 'active' : '']"
      @click="setIgTo(2, $event)"
      type="button"
    >
      <span>
        IG2
        <a
          class="tooltip"
          v-if="datasource && datasource.tooltipIG2"
          :tooltipHeader="`<span class='tooltip-header'>IG2 - </span>${datasource.tooltipIG2.value}`"
        ></a>
      </span>
    </button>
    <button
      class="button ig3"
      :class="[ig === 3 ? 'active' : '']"
      @click="setIgTo(3, $event)"
      type="button"
    >
      <span>
        IG3
        <a
          class="tooltip"
          v-if="datasource && datasource.tooltipIG3"
          :tooltipHeader="`<span class='tooltip-header'>IG3 - </span>${datasource.tooltipIG3.value}`"
        ></a>
      </span>
    </button>

    <!-- Mobile Radio Buttons -->
    <div class="radio-buttons">
      <div class="ig1">
        <label for="1" @click="setIgToMobile(1, $event)">
          <input type="radio" id="1" value="1" name="ig" :checked="ig === 1" />
          <span>IG1</span>
        </label>
        <a
          class="tooltip"
          v-if="datasource && datasource.tooltipIG1"
          :tooltipHeader="`<span class='tooltip-header'>IG1 - </span>${datasource.tooltipIG1.value}`"
        ></a>
      </div>

      <div class="ig2">
        <label for="2" @click="setIgToMobile(2, $event)">
          <input type="radio" id="2" value="2" name="ig" :checked="ig === 2" />
          <span>IG2</span>
        </label>
        <a
          class="tooltip"
          v-if="datasource && datasource.tooltipIG2"
          :tooltipHeader="`<span class='tooltip-header'>IG2 - </span>${datasource.tooltipIG2.value}`"
        ></a>
      </div>

      <div class="ig3">
        <label for="3" @click="setIgToMobile(3, $event)">
          <input type="radio" id="3" value="3" name="ig" :checked="ig === 3" />
          <span>IG3</span>
        </label>
        <a
          class="tooltip"
          v-if="datasource && datasource.tooltipIG3"
          :tooltipHeader="`<span class='tooltip-header'>IG3 - </span>${datasource.tooltipIG3.value}`"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default {
  name: 'CIS-Controls-Navigator-IG',
  props: {
    datasource: {
      type: Object,
      default: () => ({})
    },
    ig: {
      type: Number,
      default: 0
    }
  },
  emits: ['setIg'],
  mounted() {
    tippy('[tooltipHeader]', {
      content: (reference) =>
        reference.getAttribute('tooltipHeader') + '<div class="tooltip-close">X</div>',
      allowHTML: true,
      interactive: true,
      interactiveDebounce: 75,
      maxWidth: 356,
      placement: 'top-start',
      touch: true,
      onCreate(instance) {
        instance.popper.querySelector('.tooltip-close').onclick = () => {
          instance.hide();
        };
      }
    });
  },
  methods: {
    setIgTo(ig, event) {
      event.preventDefault();

      if (this.ig === ig) {
        this.$emit('setIg', 0);
        return;
      }
      this.$emit('setIg', ig);
    },
    setIgToMobile(ig, event) {
      event.preventDefault();

      this.$emit('setIg', ig);
    }
  }
};
</script>
<style lang="scss" scoped>
.cn-igs {
  grid-area: ig-buttons;
  margin-top: 2rem;
  padding: 2rem;
  border-radius: 0.8rem;
  box-shadow: 0 17px 18px 0 rgba(0, 0, 0, 0.08), 0 3px 8px 0 rgba(0, 0, 0, 0.08);

  @include tablet-up {
    margin-top: 0;
    display: flex;
    padding: 0;
    box-shadow: none;
  }

  &__title {
    display: block;
    @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $dark-blue);
    margin-bottom: 2rem;

    @include tablet-up {
      display: none;
    }
  }

  .button {
    width: 100%;
    border: none;
    border-radius: 8px;
    padding: 2rem;
    margin-bottom: 1.2rem;
    box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.08), 0 3px 8px 0 rgba(0, 0, 0, 0.08);
    @include font-styles('Arial', 2.4rem, 500, normal, 3rem, 0, $white);

    @include tablet-up {
      width: calc(100% / 3);
      margin-left: 2rem;
      margin-bottom: 0;
    }

    &:hover {
      color: $white;
    }

    span {
      display: inline-block;
      padding: 0.7rem 2.2rem 1.1rem 2.2rem;
      border-radius: 2.6rem;
    }

    &.ig1,
    &.ig2,
    &.ig3 {
      display: none;
      @include tablet-up {
        display: block;
      }
    }

    &.ig1 {
      background-color: #73ae57;

      &:hover {
        background-color: #527d3d;
      }

      &.active {
        span {
          background-color: #527d3d;
        }

        &:hover {
          span {
            background-color: #73ae57;
          }
        }
      }
    }
    &.ig2 {
      background-color: #e28f37;

      &:hover {
        background-color: #b67229;
      }

      &.active {
        span {
          background-color: #b67229;
        }

        &:hover {
          span {
            background-color: #e28f37;
          }
        }
      }
    }
    &.ig3 {
      background-color: #4eacbb;

      &:hover {
        background-color: #387e89;
      }

      &.active {
        span {
          background-color: #387e89;
        }

        &:hover {
          span {
            background-color: #4eacbb;
          }
        }
      }
    }
  }

  .tooltip {
    top: 0.7rem;

    &::after {
      background-image: url(~@/assets/images/icon-tool-tip-white.svg);
      background-repeat: no-repeat;
      background-size: contain;
      width: 1.5rem;
      height: 1.5rem;
    }
  }

  // Mobile
  .radio-buttons {
    @include tablet-up {
      display: none;
    }

    .ig1,
    .ig2,
    .ig3 {
      display: flex;
      justify-content: space-between;
      padding: 1.6rem 2rem 1.5rem 2rem;
      border-radius: 1rem;
      margin-bottom: 1rem;

      .tooltip {
        top: auto;
      }
    }

    .ig1 {
      background-color: #73ae57;
    }

    .ig2 {
      background-color: #e28f37;
    }

    .ig3 {
      background-color: #4eacbb;
    }

    input {
      display: none;
    }

    label {
      width: 75%;
      display: inline-block;
      cursor: pointer;
      margin-bottom: 0;

      @include desktop-up {
        width: 100%;
      }
    }

    span {
      display: block;
      padding-left: 4rem;
      position: relative;
      transition: all 0.25s linear;
      @include font-styles('Arial', 2rem, 500, normal, 2.6rem, 0, $white);

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        -webkit-transform: translatey(-50%);
        transform: translatey(-50%);
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        background-color: $white;
        transition: all 0.25s linear;
      }

      &:after {
        content: '';
        position: absolute;
        left: 0.5rem;
        top: 50%;
        -webkit-transform: translatey(-50%);
        transform: translatey(-50%);
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        background-color: $white;
        transition: all 0.25s linear;
      }
    }

    input:checked + span:after {
      background-color: $blue;
    }
  }

  &:deep() {
    .tippy-box {
      padding: 2rem;
      left: 1rem;

      @include desktop-up {
        padding: 5rem 2.4rem;
      }
      .tippy-content {
        text-align: left;
        line-height: 2.6rem;

        @include phone-only {
          font-weight: 300;
        }

        .tooltip-header {
          font-weight: 500;
        }
      }

      .tooltip-close {
        @include phone-only {
          font-weight: 300;
        }
      }
    }

    .tippy-box[data-placement^='bottom-start'] {
      left: -1rem;
    }

    .tippy-box[data-placement^='bottom-end'] {
      left: 2.5rem;
    }

    .tippy-box[data-placement^='top-start'] {
      top: -1rem;
      left: -1rem;

      @include desktop-up {
        top: -3rem;
      }
    }

    .tippy-box[data-placement^='top-end'] {
      top: -1rem;
      left: 2rem;

      @include desktop-up {
        top: -3rem;
      }
    }

    .tippy-box[data-placement^='top'] > .tippy-arrow:before,
    .tippy-box[data-placement^='bottom'] > .tippy-arrow:before {
      @include phone-only {
        left: 1rem;
      }
    }
  }
}
</style>
